import { TableColumn, TableData } from '@billy/design-system'
import { Text } from '@react-pdf/renderer'
import { ReactElement } from 'react'

import { SalesReportPdfTableRow } from '../SalesReportPdfTableRow'
import { getTableHeaderRowCellPdfStyles } from './utils/getTableHeaderRowCellPdfStyles'

interface SalesReportPdfTableHeaderRowProps<T extends TableData> {
  tableColumns: TableColumn<T>[]
}

export const SalesReportPdfTableHeaderRow = <T extends TableData>({
  tableColumns,
}: SalesReportPdfTableHeaderRowProps<T>): ReactElement => {
  return (
    <SalesReportPdfTableRow>
      {tableColumns.map((column, index) => {
        const isLastColumn = index === tableColumns.length - 1
        const tableHeaderRowCellPdfStyles = getTableHeaderRowCellPdfStyles({
          minWidth: column.minWidth,
          shouldHaveLastColumnStyles: isLastColumn,
        })

        return (
          <Text key={index} style={tableHeaderRowCellPdfStyles}>
            {column.Header}
          </Text>
        )
      })}
    </SalesReportPdfTableRow>
  )
}
